<template>
    <div v-if="isOpen" class="chat-interface-overlay"
        :class="{ 'chat-mobile-overlay': isMobile, 'chat-desktop-overlay': !isMobile }" @click.self="closeChat">
        <div class="chat-interface-container">
            <div class="chat-header">
                <button class="chat-header-button" @click="closeChat">
                    <i class="fa fa-arrow-left"></i>
                </button>
                <h5 class="chat-header-title" style="font-family: 'Poppins', sans-serif;">Mensagem</h5>
            </div>

            <!-- Contact Profile -->
            <div class="chat-contact-profile">
                <div class="chat-contact-avatar">
                    <img src="/img/avatar-real-chat.png" alt="Marina" class="contact-avatar-img" />
                </div>
                <div class="chat-contact-name">Marina</div>
            </div>

            <!-- Messages Area -->
            <div class="chat-messages-area" ref="messagesArea">
                <div v-for="(message, index) in messages" :key="index" class="chat-message"
                    :class="{ 'message-from-user': message.fromUser }">
                    <div class="message-bubble">
                        <p class="message-text">{{ message.text }}</p>
                        <span class="message-time">{{ message.time }}</span>
                    </div>
                    <!-- Exibe linha digitável se houver agreementInfo -->
                    <div v-if="message.agreementInfo" class="agreement-info-card">
                        <div class="agreement-info-header">
                            <i class="fa fa-check-circle"></i>
                            <span>Meu Acordo</span>
                        </div>
                        <div class="agreement-info-content">
                            <p class="agreement-info-label">Linha Digitável:</p>
                            <div 
                                class="digitable-line-container" 
                                :class="{ 'copied': copiedLineIndex === index }"
                                @click="copyDigitableLine(message.agreementInfo.digitableLine, index)">
                                <code class="digitable-line">{{ message.agreementInfo.digitableLine }}</code>
                                <i class="fa copy-icon" :class="copiedLineIndex === index ? 'fa-check' : 'fa-copy'"></i>
                                <span class="copy-hint">{{ copiedLineIndex === index ? 'Copiado!' : 'Clique para copiar' }}</span>
                            </div>
                            <div class="agreement-info-details">
                                <div class="detail-item">
                                    <span class="detail-label">Valor:</span>
                                    <span class="detail-value">{{ formatCurrency(message.agreementInfo.paymentValue) }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">Vencimento:</span>
                                    <span class="detail-value">{{ formatDate(message.agreementInfo.dueDate) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Toast de feedback de cópia -->
                <transition name="toast">
                    <div v-if="showCopyToast" class="copy-toast">
                        <i class="fa fa-check-circle"></i>
                        <span>Linha digitável copiada!</span>
                    </div>
                </transition>
                <!-- Indicador de digitando -->
                <div v-if="isTyping" class="chat-message typing-indicator">
                    <div class="message-bubble typing-bubble">
                        <div class="typing-dots">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Input Bar -->
            <div class="chat-input-bar">
                <input v-model="newMessage" type="text" class="chat-input" placeholder="Escreva sua mensagem"
                    @keyup.enter="sendMessage" />
                <!-- <div class="chat-input-icons">
                    <button class="chat-icon-button" @click="attachImage">
                        <i class="fa fa-camera"></i>
                    </button>
                    <button class="chat-icon-button" @click="attachFile">
                        <i class="fa fa-paperclip"></i>
                    </button>
                </div>  -->
                <button class="chat-send-button" :disabled="!newMessage.trim() || isSending" @click="sendMessage">
                    <i class="fa" :class="isSending ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import { EventBus } from "@/utils/EventBus";

export default {
    name: "ChatInterface",
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        userName: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            newMessage: "",
            messages: [],
            isMobile: false,
            ipUser: null,
            isTyping: false,
            isSending: false,
            copiedLine: false,
            copiedLineIndex: null,
            showCopyToast: false,
        };
    },
    computed: {
        initialMessage() {
            const formattedName = this.userName 
                ? this.userName.charAt(0).toUpperCase() + this.userName.slice(1).toLowerCase()
                : "Cliente";
            return `Oi ${formattedName}, que bom que você está aqui!\nComo posso te ajudar?`;
        },
        ...mapState("auth", ["user", "currentComponent"]),
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                this.checkMobile();
                // Previne scroll do body quando chat está aberto
                document.body.style.overflow = "hidden";
                // Carrega histórico de mensagens quando o chat abre
                this.loadHistory();
            } else {
                document.body.style.overflow = "";
            }
        },
        messages: {
            handler() {
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            },
            deep: true,
        },
        isTyping(newVal) {
            // Quando o indicador de digitando aparece/desaparece, faz scroll
            if (newVal) {
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            }
        },
    },
    mounted() {
        this.checkMobile();
        window.addEventListener("resize", this.checkMobile);
        this.ipUser = localStorage.getItem("ipUser");
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.checkMobile);
        document.body.style.overflow = "";
    },
    methods: {
        ...mapActions("auth", [
            "ActionDoLogout",
            "ActionMenuLinks",
            "ActionGetUser",
            "ActionGetWhatsText",
            "ActionContatoWhatsapp",
        ]),
        ...mapActions("meusContratos", [
            "ActionSendMessagePortoSeguro",
            "ActionHistoryMessagesPortoSeguro",
        ]),
        checkMobile() {
            this.isMobile = window.innerWidth <= 500;
        },
        getCurrentTime() {
            const now = new Date();
            const hours = now.getHours().toString().padStart(2, "0");
            const minutes = now.getMinutes().toString().padStart(2, "0");
            return `${hours}:${minutes}`;
        },
        async sendMessage() {
            if (this.isSending || !this.newMessage.trim()) return;

            const userMessage = this.newMessage.trim();

            // Bloqueia novos envios até a resposta da IA chegar
            this.isSending = true;

            // Adiciona mensagem do usuário
            this.messages.push({
                text: userMessage,
                time: this.getCurrentTime(),
                fromUser: true,
            });

            // Limpa o input
            this.newMessage = "";

            // Mostra indicador de digitando
            this.isTyping = true;

            // Envia mensagem para a API
            try {
                const document = this.user?.DocNumber || this.user?.document;
                if (!document) {
                    console.error("Documento do usuário não encontrado");
                    this.isTyping = false;
                    return;
                }

                const response = await this.ActionSendMessagePortoSeguro({
                    document: document,
                    message: userMessage,
                });

                console.log("response: " + JSON.stringify(response));

                // Remove indicador de digitando
                this.isTyping = false;

                // Adiciona resposta da IA (não descarta: usa output ou fallback se a API vier em outro formato)
                const output = response?.output ?? response?.results?.output ?? response?.message ?? "";
                const rawAgreement = response?.agreementInfo ?? response?.agreementinfo ?? response?.results?.agreementInfo ?? response?.results?.agreementinfo ?? response;
                const agreementInfo = this.normalizeAgreementInfoForCard(rawAgreement);

                const messageData = {
                    text: (typeof output === "string" && output.trim()) ? output : "Desculpe, não consegui processar sua mensagem. Tente novamente.",
                    time: this.getCurrentTime(),
                    fromUser: false,
                };

                if (agreementInfo) {
                    messageData.agreementInfo = agreementInfo;
                    this.persistAgreementInfo(document, agreementInfo);
                    setTimeout(() => {
                        EventBus.$emit("refresh-debts-keep-chat-open");
                    }, 1000);
                }

                this.messages.push(messageData);
            } catch (error) {
                console.error("Erro ao enviar mensagem:", error);
                // Remove indicador de digitando
                this.isTyping = false;
                // Mostra mensagem de erro para o usuário
                this.messages.push({
                    text: "Desculpe, ocorreu um erro ao enviar sua mensagem. Por favor, tente novamente.",
                    time: this.getCurrentTime(),
                    fromUser: false,
                });
            } finally {
                this.isSending = false;
            }
        },
        attachImage() {
            // TODO: Implementar upload de imagem
            console.log("Anexar imagem");
        },
        attachFile() {
            // TODO: Implementar upload de arquivo
            console.log("Anexar arquivo");
        },
        closeChat() {
            this.$emit("close-chat");
        },
        scrollToBottom() {
            if (this.$refs.messagesArea) {
                this.$refs.messagesArea.scrollTop =
                    this.$refs.messagesArea.scrollHeight;
            }
        },

        async loadHistory() {
            // Mensagem inicial que sempre deve aparecer primeiro
            const initialMsg = {
                text: this.initialMessage,
                time: this.getCurrentTime(),
                fromUser: false,
            };

            try {
                const document = this.user?.DocNumber || this.user?.document;
                if (!document) {
                    console.error("Documento do usuário não encontrado");
                    // Mostra apenas a mensagem inicial
                    this.messages = [initialMsg];
                    this.$nextTick(() => {
                        this.scrollToBottom();
                    });
                    return;
                }

                const rawHistory = await this.ActionHistoryMessagesPortoSeguro({
                    document: document,
                });

                // API pode retornar: array de mensagens, um único objeto (results = { message, message_type, ... }), ou objeto com lista em .messages/.data/.history
                let historyList = [];
                if (Array.isArray(rawHistory)) {
                    historyList = rawHistory;
                } else if (rawHistory && typeof rawHistory === "object") {
                    if (rawHistory.message != null || rawHistory.text != null) {
                        // Um único objeto de mensagem (ex.: results = { id, data_dialogo, hora_dialogo, message, message_type })
                        historyList = [rawHistory];
                    } else {
                        historyList = rawHistory.messages ?? rawHistory.data ?? rawHistory.history ?? [];
                    }
                }

                const toMessage = (msg) => {
                    const time = (msg.hora_dialogo || msg.time)
                        ? String(msg.hora_dialogo || msg.time).substring(0, 5)
                        : this.getCurrentTime();
                    const text = String(msg.message ?? msg.text ?? "").trim();
                    const fromUser = msg.message_type === "human" || msg.fromUser === true;
                    const base = { text, time, fromUser };
                    const rawAgreement = msg.agreementInfo ?? msg.agreementinfo ?? msg;
                    const agreementInfo = this.normalizeAgreementInfoForCard(rawAgreement);
                    if (agreementInfo) base.agreementInfo = agreementInfo;
                    return base;
                };

                const historyMessages = (Array.isArray(historyList) ? historyList : [])
                    .filter((msg) => (msg.message ?? msg.text ?? "").trim().length > 0)
                    .sort((a, b) => {
                        const dateA = new Date(`${a.data_dialogo || a.date || ""} ${a.hora_dialogo || a.time || ""}`);
                        const dateB = new Date(`${b.data_dialogo || b.date || ""} ${b.hora_dialogo || b.time || ""}`);
                        return dateA - dateB;
                    })
                    .map(toMessage);

                // Pelo menos uma mensagem válida vinda da API: mostra só essas (não mostra a mensagem padrão)
                if (historyMessages.length > 0) {
                    this.messages = historyMessages;
                } else {
                    // Nenhuma mensagem vinda da API: mostra só a mensagem padrão
                    this.messages = [initialMsg];
                }

                // Restaura linha digitável persistida (acordo fechado pela IA) para exibir ao reabrir o chat
                this.restorePersistedAgreementInfo(document);
                
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            } catch (error) {
                console.error("Erro ao carregar histórico:", error);
                // Se houver erro, mostra apenas a mensagem inicial
                this.messages = [initialMsg];
                const doc = this.user?.DocNumber || this.user?.document;
                if (doc) this.restorePersistedAgreementInfo(doc);
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            }
        },
        async saveLogcontatoWhatsApp() {
            console.log("this.ipUser dashlayout: " + JSON.stringify(this.ipUser));
            this.ActionContatoWhatsapp({
                DocNumber: this.user.DocNumber ? this.user.DocNumber : null,
                DebtorID: this.user.DebtorID ? this.user.DebtorID : null,
                tag: localStorage.getItem("tag"),
                IP: this.ipUser ? this.ipUser : "",
                OS: navigator.platform,
            });
        },
        /** Normaliza objeto da API (agreementInfo/agreementinfo, camelCase e snake_case) para o formato do card (digitableLine, paymentValue, dueDate). */
        normalizeAgreementInfoForCard(apiObj) {
            if (!apiObj || typeof apiObj !== "object") return null;
            const digitableLine = apiObj.digitableLine ?? apiObj.digitable_line ?? apiObj.codebar ?? apiObj.code_bar ?? apiObj.codigoBarras ?? apiObj.linhaDigitavel;
            const str = typeof digitableLine === "string" ? digitableLine.trim() : "";
            if (!str) return null;
            return {
                digitableLine: str,
                paymentValue: apiObj.paymentValue ?? apiObj.payment_value ?? apiObj.valor ?? apiObj.value,
                dueDate: apiObj.dueDate ?? apiObj.due_date ?? apiObj.vencimento ?? apiObj.dataVencimento,
            };
        },
        getAgreementStorageKey(documentNumber) {
            if (!documentNumber || typeof documentNumber !== "string") return null;
            const normalized = String(documentNumber).replace(/\D/g, "").trim();
            return normalized ? `portal_negociacao_chat_agreement_${normalized}` : null;
        },
        persistAgreementInfo(documentNumber, agreementInfo) {
            const key = this.getAgreementStorageKey(documentNumber);
            const normalized = agreementInfo && agreementInfo.digitableLine
                ? agreementInfo
                : this.normalizeAgreementInfoForCard(agreementInfo);
            if (!key || !normalized || !normalized.digitableLine) return;
            try {
                const toStore = {
                    digitableLine: normalized.digitableLine,
                    paymentValue: normalized.paymentValue,
                    dueDate: normalized.dueDate,
                };
                localStorage.setItem(key, JSON.stringify(toStore));
            } catch (e) {
                console.warn("Chat: falha ao persistir agreementInfo", e);
            }
        },
        restorePersistedAgreementInfo(documentNumber) {
            const key = this.getAgreementStorageKey(documentNumber);
            if (!key) return;
            const alreadyHasAgreement = this.messages.some((m) => m.agreementInfo && m.agreementInfo.digitableLine);
            if (alreadyHasAgreement) return;
            try {
                const raw = localStorage.getItem(key);
                if (!raw) return;
                const parsed = JSON.parse(raw);
                if (!parsed || !parsed.digitableLine) return;
                const agreementMsg = {
                    text: "Segue a linha digitável do seu acordo. Você pode copiá-la ao clicar.",
                    time: this.getCurrentTime(),
                    fromUser: false,
                    agreementInfo: {
                        digitableLine: parsed.digitableLine,
                        paymentValue: parsed.paymentValue,
                        dueDate: parsed.dueDate,
                    },
                };
                this.messages.push(agreementMsg);
            } catch (e) {
                console.warn("Chat: falha ao restaurar agreementInfo persistido", e);
            }
        },
        copyDigitableLine(digitableLine, messageIndex) {
            if (!digitableLine) return;
            
            // Copia para a área de transferência
            navigator.clipboard.writeText(digitableLine).then(() => {
                // Atualiza estado para mostrar feedback visual
                this.copiedLineIndex = messageIndex;
                this.showCopyToast = true;
                
                // Remove feedback após 3 segundos
                setTimeout(() => {
                    this.copiedLineIndex = null;
                }, 3000);
                
                // Remove toast após 2.5 segundos
                setTimeout(() => {
                    this.showCopyToast = false;
                }, 2500);
            }).catch(err => {
                console.error('Erro ao copiar:', err);
                // Fallback para navegadores mais antigos
                const textArea = document.createElement('textarea');
                textArea.value = digitableLine;
                textArea.style.position = 'fixed';
                textArea.style.opacity = '0';
                document.body.appendChild(textArea);
                textArea.select();
                try {
                    if (document.execCommand('copy')) {
                        // Atualiza estado para mostrar feedback visual
                        this.copiedLineIndex = messageIndex;
                        this.showCopyToast = true;
                        
                        // Remove feedback após 3 segundos
                        setTimeout(() => {
                            this.copiedLineIndex = null;
                        }, 3000);
                        
                        // Remove toast após 2.5 segundos
                        setTimeout(() => {
                            this.showCopyToast = false;
                        }, 2500);
                    }
                } catch (err) {
                    console.error('Erro ao copiar (fallback):', err);
                }
                document.body.removeChild(textArea);
            });
        },
        formatCurrency(value) {
            if (!value) return 'R$ 0,00';
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },
        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('pt-BR');
        },
    },
};
</script>

<style scoped>
.chat-interface-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;
    display: flex;
}

.chat-mobile-overlay {
    background-color: white;
    align-items: flex-start;
    justify-content: flex-start;
}

.chat-desktop-overlay {
    background-color: rgba(0, 0, 0, 0.5);
    align-items: center;
    justify-content: flex-end;
}

.chat-interface-container {
    background-color: white;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    max-width: 400px;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
}

.chat-mobile-overlay .chat-interface-container {
    max-width: 100%;
    box-shadow: none;
}

/* Header */
.chat-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 20px;
    background-color: white;
    border-bottom: 1px solid #e0e0e0;
}

.chat-header-button {
    background: none;
    border: none;
    font-size: 20px;
    color: #333;
    cursor: pointer;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.chat-header-button:hover {
    opacity: 0.7;
}

.chat-whatsapp-button {
    color: #25d366;
}

.chat-header-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin: 0;
    flex: 1;
    text-align: center;
}

/* Contact Profile */
.chat-contact-profile {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    background-color: white;
    border-bottom: 1px solid #e0e0e0;
}

.chat-contact-avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 15px;
    background-color: #1976d2;
    display: flex;
    align-items: center;
    justify-content: center;
}

.contact-avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.chat-contact-name {
    font-size: 16px;
    font-weight: 500;
    color: #333;
}

/* Messages Area */
.chat-messages-area {
    flex: 1;
    overflow-y: auto;
    background-color: #f8f8f8;
    padding: 20px;
    display: flex;
    flex-direction: column;
}

.chat-message {
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
}

.chat-message.message-from-user {
    align-items: flex-end;
}

.chat-message:not(.message-from-user) {
    align-items: flex-start;
}

.message-bubble {
    max-width: 70%;
    padding: 12px 16px;
    border-radius: 18px;
    background-color: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    position: relative;
}

.message-from-user .message-bubble {
    background-color: #2C3DA8;
    color: white;
}

.message-text {
    margin: 0 0 5px 0;
    font-size: 14px;
    color: #333;
    white-space: pre-wrap;
    word-wrap: break-word;
    line-height: 1.4;
}

.message-from-user .message-text {
    color: white;
}

.message-time {
    font-size: 11px;
    color: #999;
    display: block;
    text-align: right;
    margin-top: 5px;
}

.message-from-user .message-time {
    text-align: right;
}

/* Input Bar */
.chat-input-bar {
    display: flex;
    align-items: center;
    padding: 15px;
    background-color: white;
    border-top: 1px solid #e0e0e0;
    gap: 10px;
}

.chat-input {
    flex: 1;
    border: 1px solid #e0e0e0;
    border-radius: 25px;
    padding: 10px 15px;
    font-size: 14px;
    outline: none;
}

.chat-input:focus {
    border-color: #1976d2;
}

.chat-input-icons {
    display: flex;
    gap: 10px;
}

.chat-icon-button {
    background: none;
    border: none;
    color: #666;
    font-size: 20px;
    cursor: pointer;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.chat-icon-button:hover {
    opacity: 0.7;
}

.chat-send-button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #9c27b0;
    border: none;
    color: white;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s;
}

.chat-send-button:hover:not(:disabled) {
    background-color: #7b1fa2;
}

.chat-send-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

/* Responsividade */
@media (max-width: 500px) {
    .chat-interface-container {
        width: 100%;
        height: 100vh;
    }

    .chat-header {
        padding: 12px 15px;
    }

    .chat-header-title {
        font-size: 16px;
    }

    .chat-contact-profile {
        padding: 12px 15px;
    }

    .chat-messages-area {
        padding: 15px;
    }

    .message-bubble {
        max-width: 85%;
        padding: 10px 14px;
    }

    .chat-input-bar {
        padding: 12px;
    }

    .chat-input {
        padding: 8px 12px;
        font-size: 14px;
    }
}

/* Indicador de digitando */
.typing-indicator {
    align-items: flex-start;
}

.typing-bubble {
    background-color: white;
    padding: 12px 16px;
    min-width: 60px;
}

.typing-dots {
    display: flex;
    gap: 4px;
    align-items: center;
}

.typing-dots span {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #999;
    animation: typing 1.4s infinite;
}

.typing-dots span:nth-child(2) {
    animation-delay: 0.2s;
}

.typing-dots span:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes typing {
    0%, 60%, 100% {
        transform: translateY(0);
        opacity: 0.7;
    }
    30% {
        transform: translateY(-10px);
        opacity: 1;
    }
}

/* Agreement Info Card */
.agreement-info-card {
    margin-top: 15px;
    background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
    animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.agreement-info-header {
    display: flex;
    align-items: center;
    gap: 10px;
    color: white;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 15px;
}

.agreement-info-header i {
    font-size: 20px;
}

.agreement-info-content {
    background: white;
    border-radius: 8px;
    padding: 15px;
}

.agreement-info-label {
    font-size: 12px;
    color: #666;
    margin: 0 0 8px 0;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.digitable-line-container {
    background: #f5f5f5;
    border: 2px dashed #4caf50;
    border-radius: 8px;
    padding: 12px 15px;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
}

.digitable-line-container:hover {
    background: #e8f5e9;
    border-color: #45a049;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(76, 175, 80, 0.2);
}

.digitable-line-container.copied {
    background: #e8f5e9;
    border-color: #4caf50;
    border-style: solid;
    box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.2);
    animation: pulse 0.5s ease;
}

@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.4);
    }
    50% {
        box-shadow: 0 0 0 8px rgba(76, 175, 80, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);
    }
}

.digitable-line {
    font-family: 'Courier New', monospace;
    font-size: 14px;
    font-weight: bold;
    color: #2c3da8;
    letter-spacing: 1px;
    margin: 0;
    flex: 1;
    word-break: break-all;
}

.copy-icon {
    color: #4caf50;
    font-size: 18px;
    margin-left: 10px;
    transition: all 0.3s ease;
}

.digitable-line-container:hover .copy-icon {
    transform: scale(1.2);
}

.digitable-line-container.copied .copy-icon {
    color: #4caf50;
    transform: scale(1.3);
}

.copy-hint {
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 11px;
    color: #666;
    white-space: nowrap;
    background: white;
    padding: 2px 8px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    opacity: 0;
    transition: opacity 0.3s, color 0.3s;
}

.digitable-line-container:hover .copy-hint,
.digitable-line-container.copied .copy-hint {
    opacity: 1;
}

.digitable-line-container.copied .copy-hint {
    color: #4caf50;
    font-weight: bold;
}

.agreement-info-details {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #e0e0e0;
}

.detail-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.detail-label {
    font-size: 11px;
    color: #999;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.detail-value {
    font-size: 14px;
    font-weight: bold;
    color: #333;
}

/* Toast de feedback */
.copy-toast {
    position: fixed;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    background: #4caf50;
    color: white;
    padding: 15px 25px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
    display: flex;
    align-items: center;
    gap: 10px;
    z-index: 10001;
    font-weight: 500;
    font-size: 14px;
    animation: slideUpToast 0.3s ease-out;
}

.copy-toast i {
    font-size: 18px;
}

.toast-enter-active {
    animation: slideUpToast 0.3s ease-out;
}

.toast-leave-active {
    animation: slideDownToast 0.3s ease-in;
}

@keyframes slideUpToast {
    from {
        opacity: 0;
        transform: translateX(-50%) translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
    }
}

@keyframes slideDownToast {
    from {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
    }
    to {
        opacity: 0;
        transform: translateX(-50%) translateY(20px);
    }
}

/* Mobile adjustments */
@media (max-width: 500px) {
    .agreement-info-card {
        padding: 15px;
    }

    .digitable-line {
        font-size: 12px;
    }

    .agreement-info-details {
        flex-direction: column;
        gap: 10px;
    }

    .copy-toast {
        bottom: 80px;
        padding: 12px 20px;
        font-size: 13px;
        left: 10px;
        right: 10px;
        transform: none;
        width: calc(100% - 20px);
        max-width: none;
    }
}
</style>
